// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2fe3ef23","498":"7b9bde79","513":"9bce0425"}[chunkId] + ".chunk.js";
};